import { RESET_EDIT_RECEIVER_INFORMATION_STORE } from 'constants';
import useStore from 'hooks/useStore';
import {
  SET_ADD_RECEIVER_INFORMATION,
  SET_CURRENT_RECEIVER,
  SET_EDIT_RECEIVER_CURRENT_STEP,
  SET_EDIT_RECEIVER_INFORMATION,
} from 'store/action';

const useFormAddReceiverStore = () => {
  const { state, setState } = useStore();
  const {
    currentBusinessReceiver,
    editReceiverInformation,
    editReceiverCurrentStep,
  } = state;

  const { personalDetails, residentialAddress, accountDetails } =
    editReceiverInformation || {};

  const setEditReceiverCurrentStep = (payload) =>
    setState({
      action: SET_EDIT_RECEIVER_CURRENT_STEP,
      payload,
    });
  const resetEditReceiverInformation = () => {
    setState({
      action: SET_EDIT_RECEIVER_INFORMATION,
      payload: RESET_EDIT_RECEIVER_INFORMATION_STORE,
    });
  };

  const setAddReceiverCurrentStep = (payload) =>
    setState({
      action: SET_EDIT_RECEIVER_CURRENT_STEP,
      payload,
    });
  const setAddReceiverPersonalDetails = (payload = null) => {
    setState({
      action: SET_ADD_RECEIVER_INFORMATION,
      payload: {
        ...editReceiverInformation,
        personalDetails: payload,
      },
    });
  };
  const setAddReceiverResidentialAddress = (payload = null) => {
    setState({
      action: SET_ADD_RECEIVER_INFORMATION,
      payload: {
        ...editReceiverInformation,
        residentialAddress: payload,
      },
    });
  };
  const setAddReceiverAccountDetails = (payload = null) => {
    setState({
      action: SET_ADD_RECEIVER_INFORMATION,
      payload: {
        ...editReceiverInformation,
        accountDetails: payload,
      },
    });
  };
  const resetAddReceiverInformation = () => {
    setState({
      action: SET_ADD_RECEIVER_INFORMATION,
      payload: RESET_EDIT_RECEIVER_INFORMATION_STORE,
    });
  };

  const setCurrentReceiver = (payload) =>
    setState({
      action: SET_CURRENT_RECEIVER,
      payload,
    });
  const resetCurrentReceiver = () => {
    setCurrentReceiver(null);
  };

  return {
    ...state,

    // currentReceiver
    setCurrentReceiver,
    resetCurrentReceiver,

    personalDetails,
    residentialAddress,
    accountDetails,

    // EDIT
    editReceiverCurrentStep,
    setEditReceiverCurrentStep,
    resetEditReceiverInformation,

    // ADD | UPDATE
    setAddReceiverCurrentStep,
    setAddReceiverPersonalDetails,
    setAddReceiverResidentialAddress,
    setAddReceiverAccountDetails,
    resetAddReceiverInformation,
  };
};

export default useFormAddReceiverStore;
